import React from 'react';
import cn from 'classnames';
import styles from './TenantsWithCommentBlock.module.scss';
import CommentInfoCard from '../CommentInfoCard/CommentInfoCard';
import TenantCardGeneral from '../TenantCardGeneral/TenantCardGeneral';

const TenantsWithCommentBlock = ({
  tenants,
  className,
  onChangeButtonClick,
  changeButtonText,
  addressId,
  hasVisibleDocs = true,
  ...props
}) => {
  return (
    <div className={cn(styles.root, className)} {...props}>
      <ul className={styles.leftSide}>
        {tenants.map((tenant) => (
          <li key={tenant.id}>
            <TenantCardGeneral
              tenant={tenant}
              className={styles.card}
              style={{ backgroundColor: 'white' }}
              bgColorElement="#f3f7fc"
              onChangeButtonClick={() => onChangeButtonClick(tenant)}
              addressId={addressId}
              hasVisibleDocs={hasVisibleDocs}
            />
          </li>
        ))}
      </ul>
      <CommentInfoCard
        className={styles.rightSide}
        addressId={addressId}
        dark={false}
      />
    </div>
  );
};

export default TenantsWithCommentBlock;
